import { PermissionGuard, UnauthorizedPage } from '@shared/components/auth';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CreateEditView } from './CreateEdit';
import { Entries } from './List';
import { Receive } from './Receive';
import { ViewEditView } from './ViewEdit';

const MerchandiseV3: React.FC = () => {
    return (
        <Routes>
            {/* 📋 Ruta principal: /merchandise -> Vista List */}
            <Route index element={<Entries />} />

            {/* ➕ Crear: /merchandise/create -> Vista Create */}
            <Route path="create" element={<CreateEditView />} />

            {/* ✏️ Editar/Ver: /merchandise/edit/:id -> Vista Edit */}
            <Route path="edit/:id" element={<ViewEditView />} />

            {/* 📦 Recepción: /merchandise/:entryId/receipts/:receiptId -> Vista Reception */}
            {/* 🔒 Solo accesible para tenant_3pl */}
            <Route
                path=":entryId/receipts/:receiptId"
                element={
                    <PermissionGuard
                        teamTypes={['tenant_3pl']}
                        fallback={<UnauthorizedPage />}
                    >
                        <Receive />
                    </PermissionGuard>
                }
            />

            {/* 🔄 Redirigir rutas no encontradas a la lista */}
            <Route path="*" element={<Navigate to="/merchandise" replace />} />
        </Routes>
    );
};

export default MerchandiseV3;

